(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesdiaDetailController', VentamesdiaDetailController);

    VentamesdiaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ventamesdia'];

    function VentamesdiaDetailController($scope, $rootScope, $stateParams, previousState, entity, Ventamesdia) {
        var vm = this;

        vm.ventamesdia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:ventamesdiaUpdate', function(event, result) {
            vm.ventamesdia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
